import React from "react";

import { formatNumber, getVariance } from "utils";

import { Card, Col, MapInteractive } from "components";

export const DigifarmMap = ({ digifarmArea, digifarmShape, field, getFieldMarker, setDigifarmArea }) => (
  <>
    <Col sm={24} md={12}>
      <h4>Digifarm polygon</h4>
      <p>
        {digifarmArea ? formatNumber({ number: digifarmArea, decimalPlaces: 4 }) : 0}
        ha ({digifarmArea ? getVariance(field.size, digifarmArea, 2) : 0}% variance)
      </p>
      <Card className="map-card">
        <MapInteractive
          field={field}
          geometry={{
            geometry: digifarmShape,
          }}
          location={field.location}
          markers={[
            {
              location: getFieldMarker(field).location,
              name: getFieldMarker(field).name,
            },
          ]}
          scaleControl={true}
          updateArea={(area) => setDigifarmArea(area)}
          zoomControl={true}
        />
      </Card>
    </Col>
  </>
);
